// Initialize Firebase
require('firebase/firestore');
require('firebase/auth');

const firebase = require('firebase').default;
require('firebase/functions');

firebase.initializeApp(process.env.FIREBASE_SETTINGS);
/* var functions = firebase.functions() */

/* runFunction() {
  console.log(requestAppt);
  requestAppt({
      meetingId: 'f07OBaogi5qXXGIe4BrY',
      timeslotId: 'MDE6MDUgYW0wMToxMCBhbTIwMTgtMTAtMDE=',
      requestFrom: 'Dhno3vIajuWAJV5Ds2je',
      requestTo: 'eXRKf06EUMsB4J2HQJ5p'
  });
} */

export const db = firebase.firestore();
export const storage = firebase.storage();
/* export requestAppt = functions.httpsCallable('requestAppt'); */
export var requestAppt = firebase.functions().httpsCallable('requestAppt');
export var cancelRequest = firebase.functions().httpsCallable('cancelRequest');
export var scheduleMeeting = firebase
  .functions()
  .httpsCallable('scheduleMeeting');
export var cancelScheduled = firebase
  .functions()
  .httpsCallable('cancelScheduled');
export var rejectRequest = firebase.functions().httpsCallable('rejectRequest');
export var reschedulePending = firebase
  .functions()
  .httpsCallable('reschedulePending');
export var rescheduleScheduled = firebase
  .functions()
  .httpsCallable('rescheduleScheduled');
export var getScheduleReport = firebase
  .functions()
  .httpsCallable('getScheduleReport');
export var updateMeetingSettings = firebase
  .functions()
  .httpsCallable('updateMeetingSettings');
export var fixForAbc2023 = firebase.functions().httpsCallable('fixForAbc2023');

export { firebase };
export default db;



// WEBPACK FOOTER //
// ./src/services/firebase.js